import { HttpErrorResponse } from "@angular/common/http";
import { ErrorInterface } from "./error.service";

export function getErrorType(err: HttpErrorResponse | ErrorInterface ): string{
  if( err instanceof HttpErrorResponse){
    return err.error.error;
  }
  return err.statusText;
}
